import { type ComponentPropsWithoutRef } from 'react';

import { cn } from '@air/utils-tailwind';

export type SelectChipOptionContainerProps = ComponentPropsWithoutRef<'div'>;

export const SelectChipOptionContainer = ({ className, ...restOfProps }: SelectChipOptionContainerProps) => (
  <div
    className={cn(
      'flex w-full cursor-pointer rounded-4 bg-transparent p-1 transition-colors ads:hover:bg-hover-subtle hover:bg-gray-4',
      className,
    )}
    {...restOfProps}
  />
);
